export default __webpack_public_path__ + "static/media/1072.d01a748e.png";